import { render, staticRenderFns } from "./businessScreen.vue?vue&type=template&id=dc4a2556&"
import script from "./businessScreen.vue?vue&type=script&lang=ts&"
export * from "./businessScreen.vue?vue&type=script&lang=ts&"
import style0 from "./businessScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports